import React from "react"; 


const font_color = '#172b4d', fontFamily = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'

export const createGrpStyle = {
    control: (provided, state) =>({
      ...provided,
      borderColor:'#ced0d4a6',
      borderWidth: '1px'
    }),
}


export const customSearchStyle = {
  control: (base, state) => ({
    ...base,
    fontFamily,
    fontSize: '0.85rem',
    border: state.isFocused ? 0 : 0,
    boxShadow: state.isFocused ? 0 : 0,
    cursor: 'text',
    borderRadius: 0,
    borderBottom: 'solid 1px',
  }),

  option: (styles, { isFocused }) => {
    return {
      ...styles,
      cursor: 'pointer',
      backgroundColor: isFocused ? 'white' : 'white',
      color: isFocused ? font_color: 'black',
      lineHeight: 2,
      fontFamily
    }
  },

  input: styles => ({
    ...styles,
    color: font_color,
    fontFamily,
  }),

  menu: styles => ({
    ...styles,
    marginTop: 0,
    boxShadow: 'none',
    boxShadow: "0 2px 6px rgb(0 0 0 / 20%)!important",
    borderRadius: 0,
    fontFamily,
    color:font_color
  }),

  singleValue: styles => ({
    ...styles,
    color: font_color,
    fontFamily,
    padding:'2px 16px 2px 8px'
  }),
}